export default __webpack_public_path__ + "static/us-e84e97fa00042867db17831bda6e18ae.svg";